import OrderedArray from './collections/ordered-array';
import SettingsCollection from './extension/internal/settings-collection';
import WeakRefMap from './collections/weak-ref-map';

export default {
	OrderedArray,
	SettingsCollection,
	WeakRefMap,
};
